class MvSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let speed = 4000;
    const swiper = new Swiper(".s-mv-swiper", {
      loop: true,
      effect: 'fade',
      speed: 1500,
      autoplay: {
        delay: speed,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' + '<span class="swiper-pagination-border js-border"><span></span></span>' + '<span class="' + totalClass + '"></span>';
        }
      },
      on: {
        init: function () {
          setTimeout(() => {
            const pagiNation = document.querySelector('.swiper-pagination');
            pagiNation.classList.add('is-active');
          }, 100);
        },
        slideChangeTransitionStart: function () {
          setTimeout(() => {
            const border = document.querySelector('.js-border span');
            if (border) {
              border.style.transform = 'scaleX(0)';
              border.style.transitionDuration = '0s';
            }
          }, 100);
        },
        slideChangeTransitionEnd: function () {
          setTimeout(() => {
            const border = document.querySelector('.js-border span');
            if (border) {
              border.style.transform = 'scaleX(1)';
              border.style.transitionDuration = speed + "ms";
            }
          }, 100);
        },
      },
    });
  }
}
